/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_DELETED_APPLICATIONS_REQUEST,
  FETCH_DELETED_APPLICATIONS_SUCCESS,
  FETCH_DELETED_APPLICATIONS_FAILURE,
} from "./DeletedApplicationsTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchDeletedApplicationsRequest = () => {
  return {
    type: FETCH_DELETED_APPLICATIONS_REQUEST,
  };
};

export const fetchDeletedApplicationsSuccess = (deletedApplicationsData) => {
  return {
    type: FETCH_DELETED_APPLICATIONS_SUCCESS,
    payload: deletedApplicationsData,
  };
};

export const fetchDeletedApplicationsFailure = (error) => {
  return {
    type: FETCH_DELETED_APPLICATIONS_FAILURE,
    payload: error,
  };
};

export const fetchDeletedApplications = () => {
  return async function (dispatch) {
    dispatch(fetchDeletedApplicationsRequest());
    try {
      const data = await APIManager.getDeletedApplications();
      dispatch(fetchDeletedApplicationsSuccess(data));
    } catch (error) {
      dispatch(fetchDeletedApplicationsFailure(error));
      dispatch(commonError(error, FETCH_DELETED_APPLICATIONS_FAILURE));
    }
  };
};

export const commonError = (error, errorType) => {
  return {
    type: COMMON_ERROR,
    payload: {
      message: error.message,
      errorType: errorType,
    },
  };
};
